import { ReactNode } from 'react';
import ApplyButton from './ApplyButton';
import OnedriveButton from './OnedriveButton';
import { FilterDialog } from './FilterDialog';
import OpStructuresDialog from './OpStructuresDialog';
import { DiscountsDialog } from './DiscountsDialog';
import EconomicAccountingGroupByDialog from './GroupByDialog/EconomicAccountingGroupByDialog';
import ReportActionsRow from './ReportActionsRow';

interface ReportFilterActionsProps {
  applyDisabled?: boolean;
  onedriveDisabled?: boolean;
  children?: ReactNode;
  hasCountry?: boolean;
}

const EconomicAccountingReportFilterActions = ({
  applyDisabled,
  onedriveDisabled,
  children,
  hasCountry,
}: ReportFilterActionsProps) => (
  <ReportActionsRow data-tour="report-filter-actions">
    {children}
    <OpStructuresDialog />
    <DiscountsDialog />
    <FilterDialog />
    <EconomicAccountingGroupByDialog />
    <ApplyButton disabled={applyDisabled} />
    <OnedriveButton disabled={onedriveDisabled} hasCountry={hasCountry} />
  </ReportActionsRow>
);

export default EconomicAccountingReportFilterActions;
